import React, { useState } from "react"
import PropTypes from "prop-types"
import styles from "./nav.module.scss"
import { Link } from "gatsby"
import { cn } from "../../lib/helpers"
import LogoText from "./logo-text"
import Icon from "../icon"
import { useEffect } from "react"
import LinkButton from "../linkButton"
import GatsbySanityImage from "../Image"

const Nav = ({
  logo,
  navigationLinks,
  transparentPos,
  isHomePage,
}) => {
  const [isOpen, setOpen] = useState(false)
  const [fadeAway, setFadeAway] = useState(false)
  const [transparent, setTransparent] = useState(transparentPos !== undefined)

  useEffect(() => {
    let prevScrollpos = window.pageYOffset
    window.onscroll = function () {
      let currentScrollPos = window.pageYOffset
      setFadeAway(prevScrollpos <= currentScrollPos && currentScrollPos > 50)
      if (transparentPos !== null) {
        setTransparent(transparentPos > currentScrollPos)
      }
      prevScrollpos = currentScrollPos
    }
  }, [])

  return (
    <nav
      className={cn(
        styles.nav,
        isOpen && styles.open,
        fadeAway && styles.fade,
        transparent && styles.transparent
      )}
    >
      <Link className={styles.icon} to="/">
        <GatsbySanityImage image={logo} width={100} />
        {isHomePage && <LogoText />}
      </Link>
      <button className={styles.hamburger} onClick={() => setOpen(!isOpen)}>
        <Icon symbol={isOpen ? "close" : "hamburger"} />
        Meny
      </button>
      <ul className={styles.navigationLinks}>
        {navigationLinks
          .filter(({ slug, href }) => (slug && slug.current) || href)
          .map(({ title, slug, name, href }, index) => (
            <li key={`navigation-${index}`}>
              {href ? (
                <LinkButton href={href}>{name}</LinkButton>
              ) : (
                <LinkButton to={`/${slug.current}`} inline>
                  {title}
                </LinkButton>
              )}
            </li>
          ))}
      </ul>
    </nav>
  )
}

Nav.propTypes = {
  siteTitle: PropTypes.string,
  navigationLinks: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      slug: PropTypes.shape({
        current: PropTypes.string,
      }),
    })
  ),
}

Nav.defaultProps = {
  siteTitle: ``,
  navigationLinks: [],
}

export default Nav
